import SeoLandingPage from "@/components/SeoLandingPage";

const EvictionCleanout = () => (
  <SeoLandingPage
    slug="eviction-cleanout-wi"
    metaTitle="Eviction Cleanout WI | Landlord Trash-Out | Same-Week Service"
    metaDescription="Wisconsin eviction cleanout services for landlords and property managers, with unit clear-out, photo documentation, and broom-clean handoff."
    h1="Eviction Cleanout for Wisconsin Landlords"
    heroImage="/images/garage.jpg"
    heroIntro="The sheriff's done their job — now you need the unit empty, photographed, and rent-ready. We handle eviction cleanouts across Wisconsin with discretion and speed."
    serviceName="Eviction Cleanout"
    bullets={[
      "Complete removal of all abandoned tenant belongings, furniture, and trash.",
      "Photo documentation per Wisconsin Stat. § 704.05(5) for tenant-property records.",
      "Removal of soiled mattresses, biohazards, and pet damage.",
      "Appliance haul-away and fridge/freezer cleanout.",
      "Patch-and-paint coordination through trusted local subs.",
      "Final walkthrough with the property manager.",
    ]}
    whyUs={[
      "We know the Wisconsin landlord-tenant playbook — photos, inventory, retention windows.",
      "Same-week service for most evictions in Northeast Wisconsin.",
      "Discreet unmarked trucks if you'd rather not advertise the situation to neighbors.",
      "Trusted by property managers and individual landlords since 2018.",
    ]}
    processSteps={[
      { title: "Confirm legal possession", detail: "We start once you confirm the sheriff's writ has been executed or the tenant has surrendered the property." },
      { title: "Document and inventory", detail: "Time-stamped photos of every room and any items of value, per Wisconsin notice requirements." },
      { title: "Full cleanout", detail: "Belongings removed, trash hauled, appliances handled. We separate items you want stored for tenant claim." },
      { title: "Turn-ready handoff", detail: "Unit left broom-clean and ready for paint, carpet, and your next showing." },
    ]}
    faqs={[
      { q: "Do I need to do anything with the tenant's belongings first?", a: "Wisconsin landlords have specific notice and storage obligations under § 704.05(5). We help you document everything correctly and can coordinate storage of items the tenant may claim. Always consult your attorney for legal advice." },
      { q: "How quickly can you clear an evicted unit?", a: "Most single-unit evictions in Northeast Wisconsin are cleared in one day. Larger units or hoarder conditions may take 2–3 days." },
      { q: "Can you handle multi-unit properties?", a: "Yes. We work with property-management companies on multi-unit turnovers, including apartments, duplexes, and small complexes." },
      { q: "What does an eviction cleanout cost?", a: "Most single-unit eviction cleanouts in Wisconsin range from $400 to $1,800 depending on the volume of belongings and whether biohazards or pet damage are involved." },
    ]}
    ctaHeadline="Get the unit rent-ready this week."
  />
);

export default EvictionCleanout;
